import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { NewClientsApiService } from 'features/new-clients/api/new-clients-api.service';
import { queryClient } from 'providers';

import { NewClientsQueryKeys } from './query-keys';

const { activateClients } = NewClientsApiService();

export const useActivated = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: FormData) => {
      return activateClients(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: NewClientsQueryKeys.all,
        });
        message.success('Activated successfully');
      },
    },
  );
};
